import React from 'react';
import PropTypes from 'prop-types';

import { IframeWrap } from './styles';

const Iframe = ({ children }) => <IframeWrap>{children}</IframeWrap>;

Iframe.propTypes = { children: PropTypes.node.isRequired };

export default Iframe;
